import { render, staticRenderFns } from "./add-model.vue?vue&type=template&id=3c627edb&"
import script from "./add-model.vue?vue&type=script&lang=ts&"
export * from "./add-model.vue?vue&type=script&lang=ts&"
import style0 from "./add-model.vue?vue&type=style&index=0&id=3c627edb&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports